import { render, staticRenderFns } from "./CustomerAccountDelete.vue?vue&type=template&id=42052fee&scoped=true"
import script from "./CustomerAccountDelete.vue?vue&type=script&lang=js"
export * from "./CustomerAccountDelete.vue?vue&type=script&lang=js"
import style0 from "./CustomerAccountDelete.vue?vue&type=style&index=0&id=42052fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42052fee",
  null
  
)

export default component.exports